import React from 'react';
import { TbPlus } from 'react-icons/tb';
import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { useTarget } from 'providers/target/useTarget';
import { ContentsModuleType, IContentsModule } from 'types';
import { isImageContentsModuleType } from 'utils/guards';
import { MODULE_GROUPS, MODULE_META } from './constants';
import * as S from './style';

const { color, radius } = theme;

const grid: CSSObject = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 8,
};

const block: CSSObject = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 8,
  padding: '14px 12px',
  border: `1px solid ${color.grey100}`,
  borderRadius: radius.md,
  background: color.white,
  fontSize: 13,
  fontWeight: 600,
  color: color.grey700,
  textAlign: 'left',
  cursor: 'pointer',
  transition: 'border-color 0.15s ease, background-color 0.15s ease',
  '> svg:first-of-type': { color: color.grey500 },
  '> svg:last-of-type': {
    position: 'absolute',
    top: 12,
    right: 10,
    color: color.grey300,
  },
  ':hover': {
    borderColor: color.info,
    background: color.infoBg,
    color: color.text,
    '> svg': { color: color.info },
  },
};

function Action() {
  const { targetList, setTargetList } = useTarget();

  const handleAdd = (type: ContentsModuleType) => {
    const maxId = Math.max(0, ...targetList.map((m) => m.id));
    const module: IContentsModule = {
      id: maxId + 1,
      type,
      data:
        isImageContentsModuleType(type) || type === 'BUTTON'
          ? ''
          : '텍스트를 입력해주세요',
      ...(type === 'BUTTON' ? { link: '' } : null),
    };

    setTargetList([...targetList, module]);
  };

  return (
    <div css={S.section}>
      <p css={[S.sectionTitle, { marginBottom: 0 }]}>블록 추가</p>
      {MODULE_GROUPS.map((group) => (
        <React.Fragment key={group.title}>
          <p css={S.groupTitle}>{group.title}</p>
          <div css={grid}>
            {group.types.map((type) => (
              <button
                key={type}
                type="button"
                css={block}
                onClick={() => handleAdd(type)}
              >
                {MODULE_META[type].icon}
                {MODULE_META[type].label}
                <TbPlus size={14} />
              </button>
            ))}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default Action;
